import { useFormikContext } from "formik";
import React from "react";
import CommonTable from "../../../../candidates/Table";

export default function KeyContact({
  isLoading,
  handleTableBodyData,
  headerData,
}) {
  const { values, setFieldValue } = useFormikContext();

  return (
    <CommonTable
      marginTop="0rem"
      data={values.contact}
      columns={headerData.keyHeader}
      handleTableBodyData={(row) =>
        handleTableBodyData(row, setFieldValue, values.contact)
      }
      loading={isLoading}
      loadingRowLength={3}
    />
  );
}
